export default "__VITE_ASSET__BJDG4SUf__"